import { AppSettingsState } from './reducer';
export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS';

interface SetGeneralSettings {
    type: 'SET_GENERAL_SETTINGS';
    settings: Partial<AppSettingsState>;
}

export type AppSettingsActions = SetGeneralSettings;
